import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpRequest } from '@angular/common/http';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})


export class CompanyService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');

    }

    // Method is used for Get Company List
    GetCompanyList(CompanyId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/LoadAllCompanies?CompanyId=' + CompanyId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Add Company
    AddCompany(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/InsertUpdateCompany';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get Company Details
    GetCompanyDetails(CompanyId: any, CompSiteId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/GetCompanyDetails?CompanyId=' + CompanyId + '&CompSiteId=' + CompSiteId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Delete Company by Id
    DeleteCompanybyCompanyId(CompanyId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/DeleteCompanybyCompanyId?CompanyId=' + CompanyId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }


    // Get Company
    GetCompanyIdbyUserId(UserId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/GetCompanyIdbyUserId/?UserId=' + UserId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Set Company
    AssignCompanyIdbyUserId(UserId, CompanyId, LoginId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/AssignCompanybyUserId/?UserId=' + UserId + '&CompanyId=' + CompanyId + '&LoginId=' + LoginId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Get Company Details by Company Code
    GetCompanyDetailsByCompanyCode(CompanyCode: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/GetCompanyDetailsByCompanyCode?CompanyCode=' + CompanyCode;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Update user define Graph
    UpdateuserdefineGraph(MeterMasterID: any, registerdataIds: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Company' + '/UpdateuserdefineGraph?meterMasterId=' + MeterMasterID + '&RegisterDataIds=' + registerdataIds;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
